<template>
    <base-image
            class="intro-image"
            :url="url"
            :alt="''"
            :srcset="imageSet"/>
</template>

<script>
    import { sample } from 'lodash';
    import { mapState } from 'vuex';
    import staticPath from 'framework/filters/staticPath';

    const INTRO_IMAGES = [
        ['img-header-desktop-01.jpg', 'img-header-desktop-01@2x.jpg', 'img-header-desktop-01@3x.jpg'],
        ['img-header-desktop-02.jpg', 'img-header-desktop-02@2x.jpg', 'img-header-desktop-02@3x.jpg'],
        ['img-header-desktop-03.jpg', 'img-header-desktop-03@2x.jpg', 'img-header-desktop-03@3x.jpg'],
        ['img-header-desktop-04.jpg', 'img-header-desktop-04@2x.jpg', 'img-header-desktop-04@3x.jpg'],
        ['img-header-desktop-05.jpg', 'img-header-desktop-05@2x.jpg', 'img-header-desktop-05@3x.jpg'],
        ['img-header-desktop-06.jpg', 'img-header-desktop-06@2x.jpg', 'img-header-desktop-06@3x.jpg'],
        ['img-header-desktop-07.jpg', 'img-header-desktop-07@2x.jpg', 'img-header-desktop-07@3x.jpg'],
        ['img-header-desktop-08.jpg', 'img-header-desktop-08@2x.jpg', 'img-header-desktop-08@3x.jpg'],
    ].map(images => images.map(img => staticPath(`img/intro-images/${ img }`)));

    export default {
        data() {
            const imageSet = this.generateRandomImage();

            return {
                url: imageSet[0],
                imageSet,
            };
        },
        computed: {
            ...mapState('page', ['containers']),
        },
        methods: {
            generateRandomImage() {
                return sample(INTRO_IMAGES);
            },
        },
        watch: {
            // update randomly the image on page transitions
            containers() {
                const imageSet = this.generateRandomImage();

                this.url = imageSet[0];
                this.imageSet = imageSet;
            },
        },
    };
</script>
